export * from './ConfiguracaoDeCupomServiceAdapter'